import { Button, Form, Input, Modal } from 'antd';
import * as Hangul from 'hangul-js';
import moment from 'moment';
import React, { Component } from 'react';
import { withAlert } from 'react-alert';
import { Marker, NaverMap, Polyline } from 'react-naver-maps';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { bindActionCreators } from 'redux';
import {
  addBlindAsync,
  calcDistanceAsync,
  calcShippingDataAsync,
  getBlindAsync,
  updateOrderAsync
} from '../../api/api';
import AddressModal from '../../components/modal/AddressModal';
import KeyInputModal from '../../components/modal/KeyInputModal';
import MapModal from '../../components/modal/MapModal';
import PaymentDialog from '../../components/modal/PaymentDialog';
import PhoneInputModal from '../../components/modal/PhoneInputModal';
import PriceInputModal from '../../components/modal/PriceInputModal';
import Const from '../../const';
import '../../css/modal.scss';
import {
  defaultConst, modalErrorStyle,
  orderStatusCode,
  packAmountCodeString,
  paymentMethodCode,
  paymentMethodString,
  pickupTimeMap,
  pickupTimeValue
} from '../../lib/util/codeUtil';
import {
  calcPriceOfOrderPayments,
  checkOverPrice,
  comma,
  formatKm,
  getZoom
} from '../../lib/util/numberUtil';
import BlindMsgInputModal from './BlindMsgInputModal';
import image from '../../res/image';
import {modalStyle} from "../../lib/util/codeUtil";

const regExpPhone =
  /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;

const FormItem = Form.Item;

const getPaymentMethod = (payments) => {
  if (!payments || payments.length <= 0) return 0;
  return payments.length > 1 ? 4 : payments[0].paymentMethod;
};

class DeliveryDetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blindMsgInputModalOpen: false,
      riderIsBlocked: false,

      isEditMode: false,
      custPhone: '',
      custMessage: '',
      destAddr1: '',
      destAddr2: '',
      destAddr3: '',
      // itemPrepared: false,
      packAmount: 1,
      dist: 0,
      deliveryBasicPrice: 0,
      deliveryAddPrice: 0,
      arriveReqTime: 0,

      addrModalOpen: false,
      mapModalOpen: false,
      phoneInputModalOpen: false,
      priceInputModalOpen: false,
      keyInputModalOpen: false,

      paymentType: 3,
      orderPayments: [],
      paymentMethod: defaultConst.paymentMethod,
      pickupTime: defaultConst.pickupTime,

      frLat: 0.0,
      frLng: 0.0,
      targetLat: 0,
      targetLng: 0,

      overPriceSetting: 100000,
      overPrice: false,

      mapZoom: 0,

      qaModalOpen: false,
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    // const { data } = this.props;
  }

  componentDidUpdate(prevProps, prevState) {
    const { prevData } = prevProps;
    const { data } = this.props;

    if (prevProps.isOpen !== this.props.isOpen) {
      this.updateDeliveryData();
      if (data && data.userIdx > 0) {
        getBlindAsync(
          this.props.loginReducer.loginInfo.idx,
          this.props.data.userIdx
        ).then((data) => {
          this.setState({ riderIsBlocked: data !== null });
        });
      }
      this.setZoom();
    }

    if (prevProps.isOpen && prevState.isEditMode !== this.state.isEditMode) {
      if (data) {
        calcDistanceAsync(data.latitude, data.longitude).then(
          (shippingData) => {
            if (!shippingData) {
              Modal.error({
                title: '배달비 정보 조회 오류',
                content: (
                  <div>오류가 발생하였습니다. 다시 시도해 주십시오.</div>
                ),
                ...modalErrorStyle,
              });
            } else {
              this.setState({
                frLat: shippingData.lat,
                frLng: shippingData.lng,
                targetLat: shippingData.lat,
                targetLng: shippingData.lng,
                dist: shippingData.dist,
                deliveryBasicPrice: shippingData.deliveryBasicPrice,
                deliveryAddPrice: this.props.data
                  ? this.props.data.extraDeliveryPrice
                  : shippingData.deliveryAddPrice,
              });
            }
          }
        );

        this.formRef.current.setFieldsValue({
          custPhone: data.custPhone,
          custMessage: data.custMessage,
          destAddr1: data.destAddr1,
          destAddr2: data.destAddr2,
          destAddr3: data.destAddr3,
          orderPrice: comma(data.orderPrice),
        });

        this.setState({
          custPhone: data.custPhone,
          custMessage: data.custMessage,
          destAddr1: data.destAddr1,
          destAddr2: data.destAddr2,
          destAddr3: data.destAddr3,
          orderPrice: data.orderPrice,
          packAmount: data.packAmount,
          arriveReqTime: data.arriveReqTime,

          orderPayments: data.orderPayments,
          paymentMethod: getPaymentMethod(data.orderPayments),
          pickupTime: data.pickupTime,
        });
      }
    }
  }

  openAddrModal = () => {
    this.setState({ addrModalOpen: true });
  };
  closeAddrModal = () => {
    this.setState({ addrModalOpen: false });
  };
  openMapModal = () => {
    this.setState({
      destAddr1: this.formRef.current.getFieldValue('destAddr1'),
      destAddr2: this.formRef.current.getFieldValue('destAddr2'),
      mapModalOpen: true,
    });
  };
  closeMapModal = () => {
    this.setState({ mapModalOpen: false });
  };
  openPaymentModal = () => {
    this.setState({ paymentOpen: true });
  };
  closePaymentModal = () => {
    this.setState({ paymentOpen: false });
  };
  openPhoneInputModal = () => {
    this.setState({ phoneInputModalOpen: true });
  };
  closePhoneInputModal = () => {
    this.setState({ phoneInputModalOpen: false });
  };
  openPriceInputModal = () => {
    this.setState({ priceInputModalOpen: true });
  };
  closePriceInputModal = () => {
    this.setState({ priceInputModalOpen: false });
  };
  openKeyInputModal = () => {
    this.setState({ keyInputModalOpen: true });
  };
  closeKeyInputModal = () => {
    this.setState({ keyInputModalOpen: false });
  };
  openQaModal = () => {
    this.setState({ qaModalOpen: true });
  };
  closeQaModal = () => {
    this.setState({
      qaModalOpen: false,
    });
  };
  setAddress = (address) => {
    this.formRef.current.setFieldsValue({ destAddr1: address.roadAddr });
    this.setState({
      destAddr3: address.jibunAddr,
      addrModalOpen: false,
    });

    calcShippingDataAsync(address.roadAddr, address.jibunAddr).then((data) => {
      if (data !== null) {
        this.setState({
          targetLat: data.lat,
          targetLng: data.lng,
          dist: data.dist,
          deliveryBasicPrice: data.deliveryBasicPrice,
          deliveryAddPrice: this.props.data
            ? this.props.data.extraDeliveryPrice
            : data.deliveryAddPrice,
        });
      }
    });
  };
  onClose = (updatedOrder = null) => {
    this.setState({
      blindMsgInputModalOpen: false,
      isEditMode: false,
    });
    this.props.close(updatedOrder);
  };
  onHandle = () => {
    if (!this.state.isEditMode) {
      this.setState({ isEditMode: true });
    } else {
      this.setState({ isEditMode: false });
    }
  };
  onUpdateOverPrice = () => {
    const overPrice = checkOverPrice(
      this.formRef.current.getFieldValue('orderPrice'),
      this.state.overPrice,
      this.state.overPriceSetting
    );

    this.setState({ overPrice });
  };
  onCheckAndUpdatePaymentMethod = (paymentMethod) => {
    const cardPay = this.state.orderPayments.find(
      (x) => x.paymentMethod == paymentMethodCode.card && x.paymentAmount > 0
    );
    if (cardPay && cardPay.paymentStatus === 2) {
      Modal.error({
        title: '결제 변경',
        content: (
          <div>
            카드결제 완료건이 있습니다. 카드결제 금액을 변경하는 경우 승인취소
            후 다시 결제해야 합니다.
          </div>
        ),
        ...modalErrorStyle,
      });
      return;
    }

    if (
      this.state.paymentMethod === paymentMethodCode.installment &&
      this.state.orderPayments.length > 1 &&
      paymentMethod !== paymentMethodCode.installment
    ) {
      const self = this;
      Modal.confirm({
        ...modalStyle,
        content: '분할 결제정보가 초기화 됩니다. 결제수단을 변경 하시겠습니까?',
        okText: '확인',
        cancelText: '취소',
        onOk() {
          self.setState({
            paymentMethod,
            orderPayments: [],
          });
        },
        onCancel() {},
      });
    } else {
      this.setState({ paymentMethod });
      if (paymentMethod === paymentMethodCode.installment) {
        this.openPaymentModal();
      }
    }
  };
  handlePaymentChange = (data) => {
    let orderPrice = 0;
    let result = 'SUCCESS';
    do {
      if (
        typeof data === 'undefined' ||
        !Array.isArray(data) ||
        data.length < 1
      ) {
        result = 'INVALID_TYPE';
        break;
      }
      for (let i = 0; i < data.length; ++i) {
        if (data[i].paymentAmount === 0) {
          result = 'INVALID_PRICE';
          break;
        }
      }
      if (result !== 'SUCCESS') break;
      orderPrice = calcPriceOfOrderPayments(data);
      if (orderPrice <= 0) {
        result = 'INVALID_PRICE';
        break;
      }
    } while (false);

    // early return
    if (result !== 'SUCCESS') {
      Modal.error({
        title: '분할결제 오류',
        content: (
          <div>분할결제 정보가 올바르지 않습니다. 다시 시도해 주십시오.</div>
        ),
        ...modalErrorStyle,
      });
      return;
    }

    if (data.length === 1) {
      const self = this;
      const paymentMethod = data[0].paymentMethod;
      Modal.info({
        title: '분할결제 알림',
        content: (
          <div>
            {comma(orderPrice)}원 '{paymentMethodString[paymentMethod]}'결제 한
            건이 등록되어 결제수단이 '{paymentMethodString[paymentMethod]}
            '결제로 전환됩니다.
          </div>
        ),
        ...modalStyle,
        onOk() {
          self.setState({ paymentMethod });
          self.setState({ orderPayments: [] });
        },
      });
    } else {
      this.setState({ orderPayments: data });
    }

    this.formRef.current.setFieldsValue({ orderPrice: comma(orderPrice) });
  };
  handleSubmit = async () => {
    const self = this;
    const form = this.formRef.current;
    const orderPrice = parseInt(
      (form.getFieldValue('orderPrice') + '').replace(/,/g, '')
    );

    if (
      this.state.paymentMethod === paymentMethodCode.installment &&
      orderPrice !== calcPriceOfOrderPayments(this.state.orderPayments)
    ) {
      Modal.error({
        title: '접수요청 오류',
        content: (
          <div>분할결제 정보가 올바르지 않습니다. 다시 시도해 주십시오.</div>
        ),
        ...modalErrorStyle,
      });
      return;
    }
    const custPhone = form.getFieldValue('custPhone');
    if (custPhone === '' || isNaN(custPhone)) {
      Modal.error({
        title: '전화번호 오류',
        content: (
          <div>
            유효하지 않는 전화번호입니다. 전화번호를 올바르게 입력해주세요.
          </div>
        ),
        ...modalErrorStyle,
      });
      return;
    }

    const orderPayments =
      this.state.paymentMethod === paymentMethodCode.installment
        ? this.state.orderPayments
        : [
            {
              paymentMethod: this.state.paymentMethod,
              paymentAmount: orderPrice,
              paymentStatus: 1,
            },
          ];

    Modal.confirm({
      ...modalStyle,
      content: '배달정보를 수정하시겠습니까?',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        const custPhone = form.getFieldValue('custPhone').replace(/-/g, '');
        const custMessage = form.getFieldValue('custMessage');

        updateOrderAsync({
          idx: self.props.data.idx,
          branchIdx: self.props.loginReducer.loginInfo.branchIdx,
          latitude: parseFloat(self.state.targetLat),
          longitude: parseFloat(self.state.targetLng),
          orderPayments: orderPayments,
          destAddr3: self.state.destAddr3,
          // itemPrepared: self.state.itemPrepared,
          packAmount: self.state.packAmount,
          basicDeliveryPrice: self.state.deliveryBasicPrice,
          extraDeliveryPrice: self.state.deliveryAddPrice,
          deliveryPrice:
            self.state.deliveryBasicPrice + self.state.deliveryAddPrice,
          // arriveReqTime: pickupTimeValue[self.state.pickupTime],
          // ncashPayEnabled: true,
          orderPrice,
          custPhone,
          custMessage,
          arriveReqTime: self.state.arriveReqTime,
          duesDeliveryPrice: self.props.data.duesDeliveryPrice
            ? self.props.data.duesDeliveryPrice
            : 0,
          ...form.getFieldsValue(['destAddr1', 'destAddr2']),
        }).then((result) => {
          if (result === 'SUCCESS') {
            const data = {
              ...self.props.data,
              latitude: parseFloat(self.state.targetLat),
              longitude: parseFloat(self.state.targetLng),
              orderPayments: orderPayments,
              custPhone,
              custMessage,
              destAddr1: form.getFieldValue('destAddr1'),
              destAddr2: form.getFieldValue('destAddr2'),
              orderPrice,
              destAddr3: self.state.destAddr3,
              // itemPrepared: self.state.itemPrepared,
              packAmount: self.state.packAmount,
              basicDeliveryPrice: self.state.deliveryBasicPrice,
              extraDeliveryPrice: self.state.deliveryAddPrice,
              deliveryPrice:
                self.state.deliveryBasicPrice + self.state.deliveryAddPrice,
              arriveReqTime: self.state.arriveReqTime,
              // arriveReqTime: pickupTimeValue[self.state.pickupTime],
              // ncashPayEnabled: true,
            };

            // 지연시간 해제 상태에서 주문 접수 성공시 #refPickupTime(지연 없을때의 통상 픽업시간)을 업데이트
            if (self.state.deliveryData.delayPickupTime === 0) {
              reactLocalStorage.setObject(
                Const.appName + '#refPickupTime',
                pickupTimeValue.indexOf(self.state.arriveReqTime)
              );
            }

            self.props.alert.show('배달정보를 수정하였습니다!!');
            self.onClose(data);
          } else {
            Modal.error({
              title: '배달정보 수정',
              content: (
                <div>
                  시스템에러로 배달요청에 실패하였습니다. 잠시 후 다시
                  시도해주세요.
                </div>
              ),
              ...modalErrorStyle,
              onOk() {},
            });
          }
        });
      },
      onCancel() {},
    });
  };

  setZoom = () => {
    const { data } = this.props;
    if (data) {
      this.setState(
        {
          mapZoom: getZoom(
            { latitude: data.latitude, longitude: data.longitude },
            { latitude: data.frLatitude, longitude: data.frLongitude }
          ),
        },
      );
    }
  };

  isEnablePickupTime = (id) => {
    const fastestDelayTime =
      this.state.deliveryData.delayPickupTime + this.state.frBasicPickupTime;
    if (
      this.state.deliveryData &&
      this.state.deliveryData.delayPickupTime !== null
    ) {
      return id < fastestDelayTime ? false : true;
    }
    return true;
  };

  updateDeliveryData = () => {
    this.setState({
      deliveryData: reactLocalStorage.getObject(
        Const.appName + '#deliverydata'
      ),
      frBasicPickupTime: reactLocalStorage.getObject(
        Const.appName + '#basicPickupTime'
      ),
    });
  };

  setAddrUpdateEnabled;

  /*renderPickupTimeDropdown = (arriveReqTime) => {
    const totalDelayTime =
      this.state.deliveryData.delayPickupTime + this.state.frBasicPickupTime;
    let pickupTime;
    if (arriveReqTime !== undefined) {
      pickupTime =
        totalDelayTime > arriveReqTime ? totalDelayTime : arriveReqTime;
    } else {
      const refPickupTimeIdx = reactLocalStorage.getObject(
        Const.appName + '#refPickupTime'
      );

      const pickupTimeIdx = this.calculatePickupTimeIdx(
        refPickupTimeIdx,
        totalDelayTime
      );

      pickupTime = pickupTimeValue[pickupTimeIdx];
    }

    return pickupTimeMap[pickupTime];
  };*/

  render() {
    const { data, isOpen } = this.props;
    const navermaps = window.naver.maps;
    if (data) {
    }

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },
    };

    const skinType = Const.skinType.toUpperCase();
    return (
      <React.Fragment>
        {isOpen ? (
          <React.Fragment>
            {/* {this.state.qaModalOpen && <QaModal data={data} />} */}
            <Form
              ref={this.formRef}
              {...formItemLayout}
              onFinish={this.handleSubmit}>
              <div
                className="Modal-detail-overlay"
                onClick={() => this.onClose()}
              />

              <div className="Modal-detail ddm" style={{ textAlign: 'left', zIndex:100 }}>
                <BlindMsgInputModal
                  isOpen={this.state.blindMsgInputModalOpen}
                  close={() => this.onClose()}
                  keyin={(msg) => {
                    addBlindAsync(data.userIdx, msg, () => {
                      this.setState({
                        riderIsBlocked: true,
                        blindMsgInputModalOpen: false,
                      });
                    });
                  }}
                  ok={() => {
                    this.setState({ blindMsgInputModalOpen: false });
                  }}
                />

                {/* 타이틀 */}

                <div className="detail-title">
                  <div>배달 상세보기</div>
                  <div onClick={() => this.onClose()}>
                    {' '}
                    <img
                      style={{ display: 'inline' }}
                      src={image.closeIcon}
                      alt=""
                    />{' '}
                  </div>
                </div>

                {/* 컨텐츠 */}

                <div className="detail-content-wrapper">
                  <div className="detail-content">
                    <div className="detail-content-box">
                      <div>
                        주문번호 : <p>{data.idx}</p>
                      </div>

                      {this.state.isEditMode && (
                        <div className="detail-edit-num mobile">
                          <div> 전화번호 :</div>

                          <div className="detail-edit-content-box mobile">
                            <FormItem
                              name="custPhone"
                              value={this.state.custPhone}
                              rules={[
                                {
                                  required: true,
                                  message: '고객 전화번호를 입력해주세요',
                                },
                              ]}>
                              <Input
                                id="input-02"
                                placeholder={
                                  '고객 전화번호를 - 없이 입력해 주세요'
                                }
                                onFocus={this.openPhoneInputModal}
                                autoComplete="off"
                              />
                            </FormItem>
                            <div className="deliveryDetailKeypad-phone">
                              <PhoneInputModal
                                isOpen={this.state.phoneInputModalOpen}
                                close={this.closePhoneInputModal}
                                keyin={(data) => {
                                  const str =
                                    this.formRef.current.getFieldValue(
                                      'custPhone'
                                    );
                                  this.formRef.current.setFieldsValue({
                                    custPhone: str
                                      ? str + data + ''
                                      : data + '',
                                  });
                                }}
                                backspace={() => {
                                  const str =
                                    this.formRef.current.getFieldValue(
                                      'custPhone'
                                    );
                                  this.formRef.current.setFieldsValue({
                                    custPhone: str
                                      ? str.substr(0, str.length - 1)
                                      : '',
                                  });
                                }}
                                reset={() => {
                                  this.formRef.current.setFieldsValue({
                                    custPhone: '',
                                  });
                                }}
                                ok={() => {
                                  const value =
                                    this.formRef.current.getFieldValue(
                                      'custPhone'
                                    );
                                  if (value == '') {
                                    Modal.error({
                                      title: '전화번호 오류',
                                      content: (
                                        <div>
                                          유효하지 않는 전화번호입니다.
                                          전화번호를 올바르게 입력해주세요.
                                        </div>
                                      ),
                                      ...modalErrorStyle,
                                    });
                                  } else {
                                    this.setState({
                                      phoneInputModalOpen: false,
                                    });
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {!this.state.isEditMode && (
                        <div className="mobile">
                          전화번호 : <p>{data.custPhone}</p>
                        </div>
                      )}
                      {!this.state.isEditMode && (
                        <div className="mobile customerMessage">
                          고객요청사항: <p>{data.custMessage}</p>
                        </div>
                      )}

                      {this.state.isEditMode && (
                        <div>
                          <div className="modal-01">
                            <AddressModal
                              isOpen={this.state.addrModalOpen}
                              setAddress={this.setAddress}
                              close={this.closeAddrModal}
                            />
                          </div>

                          {/* 고객 주소 입력 */}

                          <div className="detail-bg addr edit">
                            <div>
                              <span>*</span> 고객주소 :
                            </div>

                            <div className="detail-edit-content-box">
                              <div>
                                <div>
                                  <FormItem
                                    name="destAddr1"
                                    rules={[
                                      {
                                        required: true,
                                        message: '고객 주소를 입력해주세요',
                                      },
                                    ]}>
                                    <Input
                                      id="input-01"
                                      placeholder={'고객 주소를 입력해 주세요'}
                                      disabled
                                      style={{ marginBottom: 10 }}
                                    />
                                  </FormItem>
                                </div>
                                {/*{(data.orderStatus === 1 ||
                                  (this.props.pickupTimeReducer.pickupTimeInfo
                                    .addrUpdateEnabled &&
                                    data.orderStatus === 2)) && (
                                  <div
                                    className="detail-edit-btn"
                                    onClick={this.openAddrModal}>
                                    <img
                                      style={{ display: 'inline' }}
                                      src={SearchIcon}
                                      alt=""
                                    />
                                  </div>
                                )}*/}
                                {data.orderStatus === 1 ||
                                (this.props.pickupTimeReducer.pickupTimeInfo
                                        .addrUpdateEnabled &&
                                    data.orderStatus === 2) ? (
                                    <div
                                        className="detail-edit-btn"
                                        onClick={this.openAddrModal}>
                                      <img
                                          style={{ display: 'inline' }}
                                          src={image.SearchIcon}
                                          alt=""
                                      />
                                    </div>
                                ) : null}
                              </div>
                              <div>
                                <div>
                                  <FormItem
                                    name="destAddr2"
                                    value={this.state.destAddr2}
                                    // rules={[
                                    //   {
                                    //     required: true,
                                    //     message: "상세 주소를 입력해주세요",
                                    //   },
                                    // ]}
                                  >
                                    {data.orderStatus === 1 ||
                                    (this.props.pickupTimeReducer.pickupTimeInfo
                                      .addrUpdateEnabled &&
                                      data.orderStatus === 2) ? (
                                      <Input
                                        id="input-01"
                                        placeholder={
                                          '상세 주소를 입력해 주세요'
                                        }
                                        onFocus={this.openKeyInputModal}
                                        autoComplete="off"
                                      />
                                    ) : (
                                      <Input
                                        id="input-01"
                                        placeholder={
                                          '상세 주소를 입력해 주세요'
                                        }
                                        disabled
                                        onFocus={this.openKeyInputModal}
                                        autoComplete="off"
                                      />
                                    )}
                                  </FormItem>
                                </div>
                                <div className="modal-02" style={{}}>
                                  <KeyInputModal
                                    isOpen={this.state.keyInputModalOpen}
                                    close={this.closeKeyInputModal}
                                    keyin={(data) => {
                                      const str =
                                        this.formRef.current.getFieldValue(
                                          'destAddr2'
                                        );
                                      this.formRef.current.setFieldsValue({
                                        destAddr2: str
                                          ? Hangul.assemble([
                                              ...Hangul.disassemble(str),
                                              data,
                                            ])
                                          : data + '',
                                      });
                                    }}
                                    backspace={() => {
                                      const str =
                                        this.formRef.current.getFieldValue(
                                          'destAddr2'
                                        );
                                      // console.log(str);
                                      this.formRef.current.setFieldsValue({
                                        destAddr2: str
                                          ? str.substr(0, str.length - 1)
                                          : '',
                                      });
                                    }}
                                    ok={() => {
                                      this.setState({
                                        keyInputModalOpen: false,
                                      });
                                    }}
                                    style={{ float: 'left' }}
                                  />
                                </div>
                                <div
                                  className="detail-edit-btn"
                                  onClick={() => {
                                    if (
                                      this.state.frLat === 0 ||
                                      this.state.frLng === 0 ||
                                      this.state.targetLat === 0 ||
                                      this.state.targetLng === 0
                                    ) {
                                      this.props.alert.show(
                                        '위치정보를 찾을 수 없습니다.'
                                      );
                                      return;
                                    }
                                    this.openMapModal();
                                  }}>
                                  <img
                                    style={{ display: 'inline' }}
                                    src={image.MapIcon}
                                    alt=""
                                  />
                                </div>
                                <MapModal
                                  isOpen={this.state.mapModalOpen}
                                  close={this.closeMapModal}
                                  frLat={data.frLatitude}
                                  frLng={data.frLongitude}
                                  targetLat={data.latitude}
                                  targetLng={data.longitude}
                                  dist={this.state.dist}
                                  deliveryBasicPrice={
                                    this.state.deliveryBasicPrice
                                  }
                                  deliveryAddPrice={this.state.deliveryAddPrice}
                                  destAddr1={this.state.destAddr1}
                                  destAddr2={this.state.destAddr2}
                                  destAddr3={this.state.destAddr3}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {!this.state.isEditMode && (
                        <>
                          <div className={skinType === "GOGOIT" ? "gogoit-detail-bg addr mobileoff" : "detail-bg addr mobileoff"}>
                            <div>
                              고객주소 :
                              <ul>
                                <li>
                                  {' '}
                                  <p> 도로명 </p> {data.destAddr1}
                                </li>
                                <li>
                                  {' '}
                                  <p> 지번 </p> {data.destAddr3}{' '}
                                </li>
                                <li>
                                  {' '}
                                  <p> 상세주소 </p> {data.destAddr2}{' '}
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className={skinType === "GOGOIT" ? "gogoit-detail-bg addr mobile" : "detail-bg addr mobile"}>
                            <div>
                              고객주소 :
                              <ul>
                                <li>
                                  {' '}
                                  <p> 도로명 </p>{' '}
                                  <p className="p1">{data.destAddr1}</p>
                                </li>
                                <li>
                                  {' '}
                                  <p> 지번 </p>
                                  {data.destAddr3}{' '}
                                </li>
                                <li>
                                  {' '}
                                  <p> 상세주소 </p> {data.destAddr2}{' '}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </>
                      )}

                      {/* 전화번호 */}

                      {this.state.isEditMode && (
                        <div className="detail-edit-num mobileoff">
                          <div> 전화번호 :</div>

                          <div className="detail-edit-content-box mobileoff">
                            <FormItem
                              name="custPhone"
                              value={this.state.custPhone}
                              rules={[
                                {
                                  required: true,
                                  message: '고객 전화번호를 입력해주세요',
                                },
                              ]}>
                              <Input
                                id="input-02"
                                placeholder={
                                  '고객 전화번호를 - 없이 입력해 주세요'
                                }
                                onFocus={this.openPhoneInputModal}
                                autoComplete="off"
                              />
                            </FormItem>
                            <div className="deliveryDetailKeypad-phone">
                              <PhoneInputModal
                                isOpen={this.state.phoneInputModalOpen}
                                close={this.closePhoneInputModal}
                                keyin={(data) => {
                                  const str =
                                    this.formRef.current.getFieldValue(
                                      'custPhone'
                                    );
                                  // console.log(str);
                                  this.formRef.current.setFieldsValue({
                                    custPhone: str
                                      ? str + data + ''
                                      : data + '',
                                  });
                                }}
                                backspace={() => {
                                  const str =
                                    this.formRef.current.getFieldValue(
                                      'custPhone'
                                    );
                                  // console.log(str);
                                  this.formRef.current.setFieldsValue({
                                    custPhone: str
                                      ? str.substr(0, str.length - 1)
                                      : '',
                                  });
                                }}
                                reset={() => {
                                  this.formRef.current.setFieldsValue({
                                    custPhone: '',
                                  });
                                }}
                                ok={() => {
                                  const value =
                                    this.formRef.current.getFieldValue(
                                      'custPhone'
                                    );
                                  if (value === '' || isNaN(value)) {
                                    Modal.error({
                                      title: '전화번호 오류',
                                      content: (
                                        <div>
                                          유효하지 않는 전화번호입니다.
                                          전화번호를 올바르게 입력해주세요.
                                        </div>
                                      ),
                                      ...modalErrorStyle,
                                    });
                                  } else {
                                    this.setState({
                                      phoneInputModalOpen: false,
                                    });
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {this.state.isEditMode && (
                        <div className="detail-edit-num cust-edit mobileoff">
                          <div> 고객요청사항 :</div>

                          <div className="detail-edit-content-box mobileoff">
                            <FormItem
                              name="custMessage"
                              value={this.state.custMessage}>
                              <Input
                                id="input-custMessage"
                                placeholder={'고객요청사항을 입력해주세요.'}
                              />
                            </FormItem>
                          </div>
                        </div>
                      )}

                      {!this.state.isEditMode && (
                        <div className="mobileoff customerPhone">
                          전화번호 : <p>{data.custPhone}</p>
                        </div>
                      )}
                      {!this.state.isEditMode && (
                        <div className="mobileoff cust-del customerMessage ">
                          고객요청사항 : <p>{data.custMessage}</p>
                        </div>
                      )}
                    </div>

                    <div className="detail-content-box">
                      <div className="detail-rider-name">
                        기사이름 :{' '}
                        <p>
                          {data.riderName !== null &&
                          data.riderName !== undefined
                            ? `${data.riderName} ( ${data.riderPhone} )`
                            : '-'}
                        </p>
                      </div>
                      {data.riderName !== null &&
                        !this.state.riderIsBlocked &&
                        !this.state.isEditMode && (
                          <Button
                            className="blind-btn"
                            onClick={() => {
                              this.setState({ blindMsgInputModalOpen: true });
                            }}>
                            블라인드
                          </Button>
                        )}

                      {/* 배송비 정보 입력 */}

                      {this.state.isEditMode && (
                        <div className="detail-bg edit price-edit">
                          <div className="mobileoff">
                            <span>*</span> 배송비 정보 : <br />( VAT 별도 )
                          </div>
                          <div>
                            <div className="price-edit-order mobile">
                              <div>
                                <span>*</span> 배송비 정보 : <br />( VAT 별도 )
                              </div>
                              <div>
                                주문금액
                                <div>
                                  <FormItem
                                    name="orderPrice"
                                    value={this.state.orderPrice}
                                    rules={[
                                      {
                                        required: true,
                                        message: '주문금액을 입력해주세요',
                                      },
                                    ]}>
                                    <Input
                                      id="input-02"
                                      placeholder={'주문금액을 입력해 주세요'}
                                      onFocus={this.openPriceInputModal}
                                      autoComplete="off"
                                      onChange={() => this.onUpdateOverPrice}
                                    />
                                  </FormItem>
                                  <span>원</span>
                                </div>
                              </div>
                            </div>

                            <div className={skinType === "GOGOIT" ? "gogoit-price-edit-box": "price-edit-box"}>
                              <ul>
                                <li className="mobileoff">
                                  <p> 주문금액 </p>
                                  <div>
                                    <FormItem
                                      name="orderPrice"
                                      value={this.state.orderPrice}
                                      rules={[
                                        {
                                          required: true,
                                          message: '주문금액을 입력해주세요',
                                        },
                                      ]}>
                                      <Input
                                        id="input-02"
                                        placeholder={'주문금액을 입력해 주세요'}
                                        onFocus={this.openPriceInputModal}
                                        autoComplete="off"
                                        onChange={() => this.onUpdateOverPrice}
                                      />
                                    </FormItem>
                                    <span>원</span>
                                  </div>
                                </li>
                                <div className="deliveryDetailKeypad-price mobileoff">
                                  <PriceInputModal
                                    isOpen={this.state.priceInputModalOpen}
                                    close={this.closePriceInputModal}
                                    keyadd={(data) => {
                                      let str = (
                                        this.formRef.current.getFieldValue(
                                          'orderPrice'
                                        ) + ''
                                      ).replace(/,/g, '');
                                      let value = 0;
                                      if (str && !isNaN(str))
                                        value = parseInt(str);

                                      // console.log(value);
                                      this.formRef.current.setFieldsValue({
                                        orderPrice: comma(value + data),
                                      });
                                      this.onUpdateOverPrice();
                                    }}
                                    keyin={(data) => {
                                      let str = (
                                        this.formRef.current.getFieldValue(
                                          'orderPrice'
                                        ) + ''
                                      ).replace(/,/g, '');
                                      let value = 0;
                                      if (str && !isNaN(str)) {
                                        value = parseInt(str);
                                      }
                                      this.formRef.current.setFieldsValue({
                                        orderPrice: comma(
                                          parseInt(value + '' + data)
                                        ),
                                      });
                                      this.onUpdateOverPrice();
                                    }}
                                    backspace={() => {
                                      let str = (
                                        this.formRef.current.getFieldValue(
                                          'orderPrice'
                                        ) + ''
                                      ).replace(/,/g, '');
                                      let value = 0;
                                      if (str && !isNaN(str))
                                        value = parseInt(str);

                                      // console.log(value);
                                      this.formRef.current.setFieldsValue({
                                        orderPrice: comma(parseInt(value / 10)),
                                      });
                                      this.onUpdateOverPrice();
                                    }}
                                    reset={() => {
                                      this.formRef.current.setFieldsValue({
                                        orderPrice: '',
                                      });
                                      this.onUpdateOverPrice();
                                    }}
                                    ok={() => {
                                      this.setState({
                                        priceInputModalOpen: false,
                                      });
                                    }}
                                  />
                                </div>

                                {/* <li>
                                  {" "}
                                  <p> 할증 금액 </p>{" "}
                                  {comma(this.state.deliveryAddPrice)} 원{" "}
                                </li>
                                <li>
                                  {" "}
                                  <p> 배송비 </p>{" "}
                                  {comma(this.state.deliveryBasicPrice)} 원{" "}
                                </li> */}
                                <li>
                                  {' '}
                                  <p> 총 배송비 </p>{' '}
                                  {comma(
                                    this.state.deliveryBasicPrice +
                                      this.state.deliveryAddPrice
                                  )}{' '}
                                  원{' '}
                                </li>
                              </ul>
                            </div>

                            <div>
                              <ul>
                                <li>
                                  {' '}
                                  <p> 거리 </p> {formatKm(this.state.dist)}
                                </li>
                                <li>
                                  {' '}
                                  <p> 수량 </p>
                                  <div
                                    className="amount-box"
                                    onClick={() => {
                                      this.setState({
                                        selectOpen: !this.state.selectOpen,
                                      });
                                    }}>
                                    <div
                                      className={this.state.selectOpen && skinType === "GOGOIT" ?
                                          'gogoit-amount-box-on'
                                          :
                                        this.state.selectOpen
                                          ? 'amount-box-on'
                                          : 'amount-box-off'
                                      }>
                                      묶음 ({this.state.packAmount}개)
                                      <img
                                        style={{ display: 'inline' }}
                                        src={
                                          this.state.selectOpen
                                            ? image.SelectIcon
                                            : image.UnselectIcon
                                        }
                                        alt=""
                                      />
                                    </div>

                                    {this.state.selectOpen && (
                                      <div className="amount-box-row">
                                        {Object.entries(
                                          packAmountCodeString
                                        ).map(([key, value]) => (
                                          <div style={{ display: 'block' }}>
                                            <div
                                              style={{ display: 'block' }}
                                              className={this.state.packAmount ===
                                                  parseInt(key) && skinType === "GOGOIT" ?
                                                  'gogoit-amount-box-row-on'
                                                  :
                                                this.state.packAmount ===
                                                parseInt(key)
                                                  ? 'amount-box-row-on'
                                                  : 'amount-box-row-off'
                                              }
                                              onClick={() => {
                                                this.setState({
                                                  packAmount: parseInt(key),
                                                });
                                              }}>
                                              {value}
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                </li>

                                <li>
                                  {' '}
                                  <p> 픽업시간 </p>
                                  <div
                                    className="amount-box"
                                    onClick={() => {
                                      this.setState({
                                        arriveReqTimeselectOpen:
                                          !this.state.arriveReqTimeselectOpen,
                                      });
                                    }}>
                                    <div
                                      className={
                                      this.state.arriveReqTimeselectOpen &&  skinType === "GOGOIT" ?
                                          'gogoit-amount-box-on':
                                        this.state.arriveReqTimeselectOpen
                                          ? 'amount-box-on'
                                          : 'amount-box-off'
                                      }>
                                      {this.state.deliveryData.delayPickupTime +
                                        this.state.frBasicPickupTime >
                                      this.state.arriveReqTime
                                        ? pickupTimeMap[
                                            this.state.deliveryData
                                              .delayPickupTime +
                                              this.state.frBasicPickupTime
                                          ]
                                        : pickupTimeMap[
                                            this.state.arriveReqTime
                                          ]}
                                      <img
                                        style={{ display: 'inline' }}
                                        src={
                                          this.state.arriveReqTimeselectOpen
                                            ? image.SelectIcon
                                            : image.UnselectIcon
                                        }
                                        alt=""
                                      />
                                    </div>

                                    {this.state.arriveReqTimeselectOpen && (
                                      <div className="amount-box-row">
                                        {Object.entries(pickupTimeMap).map(
                                          ([key, value]) => {
                                            if (this.isEnablePickupTime(key)) {
                                              return (
                                                <div>
                                                  <div
                                                    className={
                                                      this.state.packAmount ===
                                                      parseInt(key)
                                                        ? 'amount-box-row-on'
                                                        : 'amount-box-row-off'
                                                    }
                                                    onClick={() => {
                                                      this.setState({
                                                        arriveReqTime:
                                                          parseInt(key),
                                                      });
                                                    }}>
                                                    {value}
                                                  </div>
                                                </div>
                                              );
                                            }
                                          }
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      )}

                      {!this.state.isEditMode && (
                        <>
                          <div className="detail-bg price mobileoff">
                            <div>
                              정산내역 :
                              <ul>
                                <li>
                                  {' '}
                                  <p> 주문금액 </p> {comma(data.orderPrice)}
                                  <span>원</span>{' '}
                                </li>
                                {/* <li>
                                  {" "}
                                  <p> 추가요금 </p>{" "}
                                  {comma(data.extraDeliveryPrice)}
                                  <span>원</span>{" "}
                                </li> */}
                                <li>
                                  {' '}
                                  <p
                                    onClick={(e) => {
                                      if (e.detail < 3) return;
                                      alert(
                                        data &&
                                          typeof data === 'object' &&
                                          `기본배달료(건별가맹비 포함) : ${
                                            data.basicDeliveryPrice
                                          }\n기본배달료(건별가맹비 제외) : ${
                                            data.basicDeliveryPrice -
                                            data.duesDeliveryPrice
                                          }\n할증배달료 : ${
                                            data.extraDeliveryPrice
                                          }\n건별가맹비 : ${
                                            data.duesDeliveryPrice
                                          }`
                                      );
                                    }}>
                                    배송비
                                  </p>
                                  {comma(data.deliveryPrice)}
                                  <span>원</span>{' '}
                                </li>
                              </ul>
                            </div>
                            <div>
                              <ul>
                                <li>
                                  {' '}
                                  <p> 거리 </p> {comma(formatKm(data.distance))}
                                </li>
                                <li>
                                  {' '}
                                  <p> 수량 </p>
                                  <span>{data.packAmount}</span>
                                </li>
                                <li>
                                  <p
                                    style={{
                                      background: 'none',
                                    }}>
                                    픽업시간
                                  </p>
                                  <span>
                                    {pickupTimeMap[data.arriveReqTime]}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div
                            className="detail-bg price mobile"
                            style={{ width: 278 }}>
                            <div className="price-title">
                              {' '}
                              정산내역 : <p>주문금액</p>
                              <span>{comma(data.orderPrice)}원</span>
                            </div>
                            <div>
                              <ul>
                                <li className="mobileoff">
                                  {' '}
                                  <p> 주문금액 </p> {comma(data.orderPrice)}
                                  <span>원</span>{' '}
                                </li>
                                <li>
                                  {' '}
                                  <p> 추가요금 </p>{' '}
                                  {comma(data.extraDeliveryPrice)}
                                  <span>원</span>{' '}
                                </li>
                                <li>
                                  {' '}
                                  <p> 배송비 </p> {comma(data.deliveryPrice)}
                                  <span>원</span>{' '}
                                </li>
                              </ul>
                            </div>
                            <div>
                              <ul>
                                <li>
                                  {' '}
                                  <p> 거리 </p> {comma(formatKm(data.distance))}
                                </li>
                                <li>
                                  {' '}
                                  <p> 수량 </p>
                                  <span>{data.packAmount}</span>
                                </li>
                                <li>
                                  {' '}
                                  <p> 픽업시간 </p>
                                  <span>
                                    {pickupTimeMap[data.arriveReqTime]}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </>
                      )}

                      <div>
                        결제수단 :
                        <p>
                          {data.orderPayments
                            ? data.orderPayments.length === 0
                              ? ''
                              : data.orderPayments.length > 1
                              ? '분할'
                              : paymentMethodString[
                                  data.orderPayments[0].paymentMethod
                                ]
                            : ''}
                        </p>
                        {this.state.paymentOpen && (
                          <PaymentDialog
                            close={this.closePaymentModal}
                            orderPayments={this.state.orderPayments}
                            handlePaymentChange={this.handlePaymentChange}
                            editable={true}
                            orderPrice={
                              typeof this.formRef.current.getFieldValue(
                                'orderPrice'
                              ) === 'undefined'
                                ? 0
                                : parseInt(
                                    (
                                      this.formRef.current.getFieldValue(
                                        'orderPrice'
                                      ) + ''
                                    ).replace(/,/g, '')
                                  )
                            }
                          />
                        )}
                        {this.state.isEditMode && (
                          <div className={skinType === "GOGOIT" ? "gogoit-detail-payment-type" : "detail-payment-type"}>
                            <ul>
                              <li
                                key={3}
                                className={
                                  'payment-btn' +
                                  (paymentMethodCode.advance ===
                                  this.state.paymentMethod
                                    ? ' active'
                                    : '')
                                }
                                onClick={() =>
                                  this.onCheckAndUpdatePaymentMethod(
                                    paymentMethodCode.advance
                                  )
                                }>
                                {paymentMethodString[paymentMethodCode.advance]}
                              </li>
                              <li
                                key={4}
                                className={
                                  'payment-btn' +
                                  (paymentMethodCode.installment ===
                                  this.state.paymentMethod
                                    ? ' active'
                                    : '')
                                }
                                onClick={() =>
                                  this.onCheckAndUpdatePaymentMethod(
                                    paymentMethodCode.installment
                                  )
                                }>
                                {
                                  paymentMethodString[
                                    paymentMethodCode.installment
                                  ]
                                }
                              </li>
                              <li
                                key={1}
                                className={
                                  'payment-btn' +
                                  (paymentMethodCode.card ===
                                  this.state.paymentMethod
                                    ? ' active'
                                    : '')
                                }
                                onClick={() =>
                                  this.onCheckAndUpdatePaymentMethod(
                                    paymentMethodCode.card
                                  )
                                }>
                                {paymentMethodString[paymentMethodCode.card]}
                              </li>
                              <li
                                key={2}
                                className={
                                  'payment-btn' +
                                  (paymentMethodCode.cash ===
                                  this.state.paymentMethod
                                    ? ' active'
                                    : '')
                                }
                                onClick={() =>
                                  this.onCheckAndUpdatePaymentMethod(
                                    paymentMethodCode.cash
                                  )
                                }>
                                {paymentMethodString[paymentMethodCode.cash]}
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="detail-content-box-warp">
                      <div className="detail-content-box no3">
                        <ul>
                          <li>
                            {' '}
                            접수시간{' '}
                            <p>
                              {moment(data.orderDate).format(
                                'YYYY-MM-DD HH:mm'
                              )}
                            </p>{' '}
                          </li>
                          <li>
                            {' '}
                            배차시간{' '}
                            <p>
                              {data.assignDate &&
                                moment(data.assignDate).format(
                                  'YYYY-MM-DD HH:mm'
                                )}
                            </p>{' '}
                          </li>
                          <li>
                            {' '}
                            픽업시간{' '}
                            <p>
                              {data.pickupDate &&
                                moment(data.pickupDate).format(
                                  'YYYY-MM-DD HH:mm'
                                )}
                            </p>{' '}
                          </li>
                          <li>
                            {' '}
                            완료시간{' '}
                            <p>
                              {data.completeDate &&
                                moment(data.completeDate).format(
                                  'YYYY-MM-DD HH:mm'
                                )}
                            </p>{' '}
                          </li>
                        </ul>
                      </div>

                      <div className={skinType === "GOGOIT" ? "gogoit-detail-btn-box" : "detail-btn-box"}>
                        {data.orderStatus !== orderStatusCode.complete &&
                          data.orderStatus !== orderStatusCode.cancel && (
                            <div className="detail-btn-box-1">
                              <Button
                                type="primary"
                                className="detail-modal-btn"
                                onClick={() => this.onHandle()}>
                                {this.state.isEditMode ? '취소' : `수정하기`}
                              </Button>
                            </div>
                          )}

                        {this.state.isEditMode && (
                          <div className="detail-btn-box-2">
                            <Button
                              className="body-element-block8-title"
                              type="primary"
                              htmlType="submit">
                              확인
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="detail-content">
                    <div className="detail-content-box-map">
                      <NaverMap
                        zoom={this.state.mapZoom}
                        center={navermaps.LatLng(
                          (data.latitude + data.frLatitude) / 2,
                          (data.longitude + data.frLongitude) / 2
                        )}
                        className="detail-content-map">
                        <Marker
                          position={navermaps.LatLng(
                            data.latitude,
                            data.longitude
                          )}
                          icon={image.MarkerTargetIcon}
                        />
                        <Polyline
                          path={[
                            navermaps.LatLng(data.latitude, data.longitude),
                            navermaps.LatLng(data.frLatitude, data.frLongitude),
                          ]}
                          strokeColor="black"
                          strokeWeight={5}
                        />
                        <Marker
                          position={navermaps.LatLng(
                            data.frLatitude,
                            data.frLongitude
                          )}
                          icon={image.FranchiseColorIcon}
                        />
                      </NaverMap>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginReducer, pickupTimeReducer } = state;
  return { loginReducer, pickupTimeReducer };
};
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);
export default withAlert()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(DeliveryDetailModal))
);
